// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { ChartSquare, Story } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  resume: Story,
  metrics: ChartSquare
};

// ==============================|| MENU ITEMS - OVERVIEW ||============================== //

const overview: NavItemType = {
  id: 'overview-group',
  title: <FormattedMessage id="common.menu.overview.group" />,
  type: 'group',
  children: [
    {
      id: 'resume',
      title: <FormattedMessage id="common.others.resume" />,
      type: 'item',
      url: '/overview',
      icon: icons.resume,
      breadcrumbs: false
    },
    {
      id: 'metrics',
      title: <FormattedMessage id="metrics.title" />,
      type: 'item',
      url: '/metrics',
      icon: icons.metrics,
      breadcrumbs: true,
      chip: {
        label: 'beta',
        color: 'info',
        size: 'small',
        variant: 'outlined'
      }
    }
  ]
};

export default overview;
